import { Box } from "@chakra-ui/react";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Mode } from ".";
import { LeftNavProvider } from "./LeftNavContext";
import { NavLevelElement, findCurrentLevel } from "./NavLevel";

type Props = {
  children: NavLevelElement | NavLevelElement[];
  isOpen: boolean;
  initialLevel?: number;
};

export function LeftNav({ children, isOpen }: Props) {
  const mode: Mode = isOpen ? "full" : "compact";
  const location = useLocation();
  const initialLevel = useMemo(() => {
    return findCurrentLevel(location, children);
  }, [children, location]);

  const [level, setLevel] = useState(initialLevel);

  useEffect(() => {
    setLevel(findCurrentLevel(location, children));
  }, [location, setLevel, children]);

  const currentLevel = useMemo(() => {
    let levels = [0];
    let currentLevel = level;

    if (Array.isArray(children)) {
      levels = _.uniq(children.map((child) => child.props.level ?? 0)).sort();
    }

    currentLevel = _.clamp(level, 0, _.max(levels) ?? 0);
    return currentLevel;
  }, [children, level]);

  return (
    <LeftNavProvider
      mode={mode}
      currentLevel={currentLevel}
      setLevel={setLevel}
    >
      <Box
        as="nav"
        display="flex"
        bg="gray.50"
        flexDirection="column"
        height="100%"
        position="relative"
        overflowY="auto"
        overflowX="hidden"
        transition="width 0.25s ease-in-out"
        {...(mode === "compact" ? { width: "4.5rem" } : { width: "20rem" })}
      >
        {children}
      </Box>
    </LeftNavProvider>
  );
}
